<p>sales-return-detail works!</p>
